module.exports = __webpack_public_path__ + "img/gaming.57568814.svg";